import './styles.sass'

import React, { FC } from 'react';

interface IGgButton {
  label?: string
  onPress?: () => void
  className?: string
  type?: any
  stylesType?: 'default' | 'success' | 'delete' | 'border' | 'round'
  disabled?: boolean
  icon?: IIcon
  style?: any
}

interface IIcon {
  leftIcon?: any
  rightIcon?: any
}

const Button: FC<IGgButton> = ({ label, onPress, className, type, stylesType = 'default', disabled = false, icon, style  }) => {
  return (
    <button disabled={disabled} type={type ? type : 'button'} className={`buttonComponent ${stylesType} ${className} ${disabled && 'disabled'}`} onClick={onPress} style={style}>
      {icon?.leftIcon && (
        // @ts-ignore
        <span className='icon-container'>{icon.leftIcon}</span>
      )}
      {label}
      {icon?.rightIcon && (
        // @ts-ignore
        <span className='icon-container'>{icon.rightIcon}</span>
      )}
    </button>
  );
};

export default Button;
